import type { IColorUser, UserRole } from '@/Auth';

import { getRoles } from './roles';

export function getFullName(user: IColorUser): string {
  return `${user.first_name} ${user.last_name}`;
}

export function hasRole(user: IColorUser, role: UserRole): boolean {
  const userRoles: UserRole[] = getRoles(user);
  return userRoles.includes(role);
}

export function hasAnyRoles(user: IColorUser, roles: UserRole[]): boolean {
  const userRoles: UserRole[] = getRoles(user);
  return roles.some((role) => userRoles.includes(role));
}
